<template>
  <div>
    <el-menu id="mapDatamenu" v-loading="loading" :unique-opened="true" menu-trigger="click" class="menu-select-chart" mode="horizontal" @open="menuOpened = true">
      <el-submenu index="1" class="fake-selector">
        <template
          slot="title"
        >
          <span>{{ $t(map_data_name) }}</span> <em class="el-icon-arrow-down" />
        </template>
        <el-menu-item index="2" @click="setSelectedElementMap({ label: 'satellite-view-map', value: 'satellite_view', id_typology: 0, title: ['satellite-view-map'], name: 'satellite-view-map', premium: false })">
          <div class="dis-flex">
            <div class="satellite-view-map-text">{{ $t('satellite-view-map') }}</div>
          </div>
        </el-menu-item>
        <el-menu-item index="2" @click="setSelectedElementMap({ label: 'wms-view-map', value: 'wms_view', id_typology: 0, title: ['wms-view-map'], name: 'wms-view-map', premium: false })">
          <div class="dis-flex">
            <div class="satellite-view-map-text">{{ $t('wms-view-map') }}</div>
          </div>
        </el-menu-item>
        <!-- Nivel 1 -->
        <span v-if="maps && maps.length > 0">
          <!-- Check para premium nivel 1 -->
          <span v-for="(item1, index1) in maps" :key="index1 + '-lvl1' + '-' + index1 + '-lvl1'" class="black_color_hover">
            <!-- Solo si hay nivel 1 -->
            <el-menu-item
              v-if="item1.child.length === 0"
              :index="'1-' + item1.id"
              @click="setSelectedElementMap({ label: item1.name, value: item1.id, id_typology: 0, title: [item1.name], name: item1.name, obj: item1 })"
            >
              <el-tooltip
                :disabled="getTooltipDesc(item1) === ''"
                :visible-arrow="false"
                :open-delay="450"
                class="item"
                popper-class="tooltip-selector-map"
                effect="light"
                placement="right-start"
              >
                <div slot="content" v-html="getTooltipDesc(item1)" />
                <div class="dis-flex">
                  <div>{{ $t(item1.name) }}</div>

                </div>
              </el-tooltip>
            </el-menu-item>
            <!-- En caso de que tenga nivel 2 -->
            <el-submenu v-else :index="'1-' + item1.id" :class="['black_color_hover']">
              <template slot="title">
                <div class="dis-flex">
                  <div>
                    {{ $t(item1.name) }}
                  </div>

                </div>
              </template>
              <!-- Bucle para nivel 2 -->
              <span v-for="(item2, index2) in item1.child" :key="index2 + '-lvl2'">
                <!-- Check para premium nivel 2 -->
                <span>
                  <!-- Solo si hay nivel 2 -->
                  <el-menu-item
                    v-if="item2.child === undefined || (item2.child && item2.child.length === 0)"
                    :class="['black_color_hover']"
                    :index="'1-' + item1.id + '-' + item2.id + '-' + index2 + '-lvl2'"
                    @click="
                      setSelectedElementMap({ label: item2.name, value: item2.id, id_typology: item1.id, title: [item1.name, item2.name], name: item2.name, obj: item2 })
                    "
                  >
                    <el-tooltip
                      :disabled="getTooltipDesc(item2) === ''"
                      :visible-arrow="false"
                      :open-delay="450"
                      class="item"
                      popper-class="tooltip-selector-map"
                      effect="light"
                      placement="right-start"
                    >
                      <div slot="content">
                        <div v-html="getTooltipDesc(item2)" />
                        <div class="date-source-description-tooltip">
                          <br>
                          <span><strong>{{ $t('maps.source') }}: </strong>{{ item2.source }} </span>
                        </div>
                      </div>
                      <div class="dis-flex">
                        <div>{{ $t(item2.name) }}</div>

                        <div v-if="item2.icon !== 'False' && item2.icon !== false">
                          <img :src="getTypoIcon(item2.icon)" class="tipoico icono-select-typology" alt="image">
                        </div>
                      </div>
                    </el-tooltip>
                  </el-menu-item>
                  <!-- En caso de que tenga nivel 3 -->
                  <el-submenu v-else-if="item2.child && item2.child.length > 0" :index="'1-' + item1.id + '-' + item2.id" :class="['black_color_hover']" class="eleui-fix-selector-height">
                    <template slot="title">
                      <div class="dis-flex">
                        <div>{{ $t(item2.name) }}</div>
                        <div v-if="item2.icon !== 'False' && item2.icon !== false">
                          <img :src="getTypoIcon(item2.icon)" class="tipoico icono-select-typology" alt="image">
                        </div>

                      </div>
                    </template>
                    <!-- Bucle para el nivel 3 -->
                    <span v-for="(item3, index3) in item2.child" :key="index3 + '-lvl3'">
                      <!-- Check para premium nivel 3 -->
                      <span>
                        <el-menu-item
                          :class="['black_color_hover']"
                          :index="'1-' + item1.id + '-' + item2.id + '-' + item3.id + '-' + index3 + '-lvl3'"
                          @click="
                            setSelectedElementMap({
                              label: item3.name,
                              value: item3.id,
                              id_typology: item2.id,
                              title: [item1.name, item2.name, item3.name],
                              name: item3.name,
                              obj: item3,
                            })
                          "
                        >
                          <el-tooltip
                            :disabled="getTooltipDesc(item3) === ''"
                            :visible-arrow="false"
                            :open-delay="450"
                            class="item"
                            popper-class="tooltip-selector-map"
                            effect="light"
                            placement="right-start"
                          >
                            <div slot="content">
                              <div v-html="getTooltipDesc(item3)" />
                              <div class="date-source-description-tooltip">
                                <br>
                                <span><strong>{{ $t('maps.source') }}: </strong>{{ item3.source }} </span>
                              </div>
                            </div>
                            <div class="dis-flex">
                              <div>{{ $t(item3.name) }}</div>
                            </div>
                          </el-tooltip>
                        </el-menu-item>
                      </span>
                    </span>
                  </el-submenu>
                </span>
              </span>
            </el-submenu>
          </span>
        </span>
      </el-submenu>
    </el-menu>
    <!-- Fin controles -->
  </div>
</template>

<script>
import residentialicon from '@/assets/brains_icons/residential_tipo.svg'
import officeicon from '@/assets/brains_icons/office_tipo.svg'
import retailicon from '@/assets/brains_icons/retail_tipo.svg'
import industrialicon from '@/assets/brains_icons/Industrial_tipo.svg'
import { mapState } from 'vuex'

export default {
  name: 'MapDataSelector',
  components: {},
  data() {
    return {
      loading: false,
      map_data_name: 'satellite-view-map',
      maptitle_array: ['dataSelectors.sale-market', 'dataSelectors.residential', 'dataSelectors.asking-sqm']
    }
  },
  computed: {
    ...mapState('maps', {
      mapsinit: (state) => state.availablemaps
    }),
    maps: function() {
      return this.mapsinit.item1
    }
  },
  mounted() {
    // var vm = this
    const vm = this
    if (vm.maps === undefined) {
      setTimeout(() => { vm.loadSelectorConfig() }, 1000)
    }
  },
  methods: {
    getTooltipDesc(item) {
      return item.description_it
    },
    loadSelectorConfig() {
      var vm = this
      vm.loading = true
      vm.$store.dispatch('maps/loadmaps').then(() => {
        vm.loading = false
        if (vm.$route.query.latitude && vm.$route.query.longitude && vm.$route.query.level && vm.$route.query.map) {
          var mapItem
          vm.maps.forEach(element => {
            element.child.forEach(element2 => {
              if (element2.child) {
                element2.child.forEach(item => {
                  if (item.id === vm.$route.query.map) {
                    mapItem = element2.child.find((item) => item.id === vm.$route.query.map)
                    console.log(mapItem)
                  }
                })
              }
            })
          })
          const selectedmap = {
            obj: mapItem,
            value: mapItem.id,
            id_typology: mapItem.parentId,
            name: mapItem.name,
            title: mapItem.name
          }
          vm.setSelectedElementMap(selectedmap)
        }
        // console.log(vm.maps)
      }).catch((e) => {
        vm.loading = false
        vm.$message({
          message: e,
          type: 'error'
        })
      })
    },
    getTypoIcon(iconstr) {
      if (iconstr === 'residentialicon') { return residentialicon }
      if (iconstr === 'officeicon') { return officeicon }
      if (iconstr === 'retailicon') { return retailicon }
      if (iconstr === 'industrialicon') { return industrialicon }
    },
    typologyIcon(label) {
      var icon_typo = residentialicon

      switch (label) {
        case this.$t('dataSelectors.retail'):
          icon_typo = retailicon
          break
        case this.$t('dataSelectors.office'):
          icon_typo = officeicon
          break
        case this.$t('dataSelectors.industrial'):
          icon_typo = industrialicon
          break
        default:
          break
      }

      return icon_typo
    },
    /**
     * Función para establecer el valor actual seleccionado en el data de map
     */
    setSelectedElementMap(item) {
      const vm = this
      const selectedmap = {
        mapvisualizationobject: item.obj,
        mapvisualizationval: item.value,
        typologieMap: item.id_typology,
        map_data_name: item.name,
        maptitle_array: item.title,
        mapvisualizationtitle: item.title,
        mapvisualizationtitle_clean: vm.$t(item.name)
      }
      vm.loading = true
      vm.$store.dispatch('maps/setselectedmap', selectedmap).then(() => {
        vm.loading = false
        vm.map_data_name = item.name
        vm.maptitle_array = item.title
      }).catch((error) => {
        vm.loading = false
        console.error(error)
        vm.$message({
          message: vm.$t('mapDataSelector.invalidmap'),
          type: 'error'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tipoico {
  height: 25px;
  width: 25px;
}
.prem_icon {
  height: 20px;
  width: 20px;
}
</style>

<style lang="scss">
.eleui-fix-selector-height > .el-menu--horizontal > .el-menu--popup-right-start{
  max-height: 437px;
  overflow-y: scroll;
}
// .grey_color_hover {
//   & > div > div { color: rgb(192, 192, 192) }

//   &:hover {
//     background-color: lightgrey !important;
//   }

//   & .el-submenu__title {
//     color: rgb(192, 192, 192) !important;

//     &:hover {
//       background-color: lightgrey !important;
//     }
//   }
// }
.satellite-view-map-text {
  color: black;

  &:hover {
    color: white;
  }
}
</style>
